
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { FilterableMasterSelectableMixin } from "../../../system/selectors/mixins";
import { DomainRegistry } from "../../../../domain";
import { DocumentKind } from "../../../../domain/document";

@Component
export default class DocumentKindSelectableMixin extends Mixins(FilterableMasterSelectableMixin) {
  values: DocumentKind[];

  @Prop({ default: null })
  defaultSelectedDocumentKindCodes: string[];

  @Watch("values")
  onValuesUpdated(newValue: DocumentKind[], oldValue: DocumentKind[]) {
    // 初回にデフォルト選択をセットする
    if (!oldValue && newValue) {
      if (!this.editingSource || this.editingSource.length === 0) {
        this.editingSource = newValue.filter(p => this.isDefaultSelectedDocumentKind(p));
      }
    }
  }

  private isDefaultSelectedDocumentKind(documentKind: DocumentKind): boolean {
    return this.defaultSelectedDocumentKindCodes
      && this.defaultSelectedDocumentKindCodes.some(c => c === documentKind.id);
  }

  async created() {
    try {
      const repository = DomainRegistry.document.getDocumentKindRepository();
      this.values = this.sortByDefaultSelectedParameter(await repository.getAllEntities());
    } catch (e) {
      this.$error(
        this.$wording.format.attributes.name + "種別情報取得失敗",
        this.$wording.format.attributes.name + "種別情報を取得できませんでした。",
        e,
      );
    }
  }

  private sortByDefaultSelectedParameter(documentKinds: DocumentKind[]): DocumentKind[] {
    if (!documentKinds) { return []; }
    const selectedOptions: DocumentKind[] = [];
    const otherOptions: DocumentKind[] = [];
    for (const documentKind of documentKinds) {
      if (this.isDefaultSelectedDocumentKind(documentKind)) {
        selectedOptions.push(documentKind);
      } else {
        otherOptions.push(documentKind);
      }
    }
    return selectedOptions.concat(otherOptions);
  }
}
